module.exports = __webpack_public_path__ + "img/cineflick-logo.10fef131.png";